import React from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryButton, TextButton } from '@bibliocommons/base-buttons';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import BorrowingBatchActionsOverlay from '../../shared/BorrowingBatchActionsOverlay';
import HoldsPauseDateSelect from '../HoldsPauseDateSelect';

import './PauseHoldsBatchAction.scss';

export class PauseHoldsBatchActions extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDatePicker: false,
      suspendDates: {}
    };
    this.bindAll();
  }

  handleBatchedPauseHolds() {
    const { accountId, items, handlePauseHolds, supportsSuspendHoldEndDate } = this.props;
    let { suspendDates } = this.state;

    if (!supportsSuspendHoldEndDate) {
      suspendDates = {
        startDate: null,
        endDate: moment().add(1, 'day').format()
      };
    }

    const holdIds = items
      .map(item => item.get('id'))
      .toSet()
      .toList()
      .toJS();

    handlePauseHolds({
      accountId,
      messagingId: '',
      holdIds,
      workflowId: '',
      suspended: {
        ...suspendDates,
        status: true
      }
    });

    this.props.handleClose();
  }

  renderFooter() {
    return (
      <div className="pause-hold-date-submit">
        <PrimaryButton className="pull-left" disabled={false} handleClick={() => this.handleBatchedPauseHolds()}>
          <FormattedMessage id="pause_confirmation_holds_button_yes" />
        </PrimaryButton>
        <TextButton className="btn btn-link pull-left" handleClick={this.props.handleClose}>
          <FormattedMessage id="button_nevermind_close" />
        </TextButton>
      </div>
    );
  }

  render() {
    return (
      <BorrowingBatchActionsOverlay
        open={this.props.open}
        className="cp-pause-hold-date-batch-actions-overlay"
        handleClose={this.props.handleClose}
        header={<FormattedMessage id="pause_holds_date_header" values={{ count: this.props.items.size }} />}
        subtitle={
          <div>
            <FormattedMessage tagName="p" id="pause_workflow_info_text" />
            {(this.props.supportsSuspendHoldStartDate || this.props.supportsSuspendHoldEndDate) &&
              <FormattedMessage tagName="p" id="holds_chosen_dates_subtitle" />
            }
          </div>
        }
        footer={this.renderFooter()}>
        <HoldsPauseDateSelect
          enableStartDate={this.props.supportsSuspendHoldStartDate}
          enableEndDate={this.props.supportsSuspendHoldEndDate}
          onSelectDates={(suspendDates) => this.setState({ suspendDates })} />
      </BorrowingBatchActionsOverlay>
    );
  }

}

export default PauseHoldsBatchActions;



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/PauseHoldsBatchActions/PauseHoldsBatchActions.jsx